// Listado de choferes: ID Sisven, Nombre y Apellido, Sucursal, Punto de Venta Hipergas y Punto de Venta Autogas.
// Permite búsqueda global y filtros por columna.

import { useMemo, useEffect, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { Container, Box, Typography } from "@mui/material";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import Navbar from "../../Navbar";
import { getData } from "../../../services/library";

export default function TablaChoferes() {
  const [choferes, setChoferes] = useState([]);
  const globalTheme = useTheme();

  useEffect(() => {
    getData("/choferes", setChoferes);
  }, []);

  const columns = useMemo(
    () => [
      {
        header: "ID Sisven Hipergas",
        id: "id_sisven",
        accessorFn: (row) => row.id_sisven?.toString() ?? "",
        size: 80,
        filterVariant: "text",
        filterFn: "includesString",
        enableGlobalFilter: true,
      },
      {
        header: "ID Sisven Autogas",
        id: "id_sisven_autogas",
        accessorFn: (row) => row.id_sisven_autogas?.toString() ?? "",
        size: 80,
        filterVariant: "text",
        filterFn: "includesString",
        enableGlobalFilter: true,
      },
      {
        header: "Nombre y Apellido",
        accessorKey: "nombre_apellido",
        size: 200,
        filterVariant: "text",
        filterFn: "includesString",
        enableGlobalFilter: true,
      },
      {
        header: "Sucursal",
        id: "sucursal",
        accessorFn: (row) => row.sucursal ?? "",
        size: 120,
        filterVariant: "text",
        filterFn: "includesString",
        enableGlobalFilter: true,
      },
      {
        header: "Pto. Venta Hipergas",
        id: "pto_vta_hipergas",
        accessorFn: (row) => row.pto_vta_hipergas?.toString() ?? "",
        size: 120,
        filterVariant: "text",
        filterFn: "includesString",
        enableGlobalFilter: true,
      },
      {
        header: "Pto. Venta Autogas",
        id: "pto_vta_autogas",
        accessorFn: (row) => row.pto_vta_autogas?.toString() ?? "",
        size: 120,
        filterVariant: "text",
        filterFn: "includesString",
        enableGlobalFilter: true,
      },
    ],
    [],
  );

  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary,
          info: { main: "rgb(255,122,0)" },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)"
                : "#000",
          },
        },
        typography: {
          button: { textTransform: "none", fontSize: "1rem" },
        },
        components: {
          MuiTooltip: {
            styleOverrides: { tooltip: { fontSize: "0.8rem" } },
          },
        },
      }),
    [globalTheme],
  );

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 15,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    showColumnFilters: true,
    pagination: { pageIndex: 0, pageSize: 15 },
  };

  return (
    <>
      <Navbar />
      <Container maxWidth="xl" sx={{ mt: 2, mb: 4 }}>
        <ThemeProvider theme={tableTheme}>
          <Box boxShadow={3}>
            <MaterialReactTable
              columns={columns}
              data={choferes}
              initialState={initialState}
              localization={MRT_Localization_ES}
              layoutMode="grid"
              enableColumnResizing
              enableColumnActions={false}
              enableColumnDragging={false}
              enableDensityToggle={false}
              enableHiding={false}
              enableColumnFilters
              enableGlobalFilter
              globalFilterFn="includesString"
              muiTableHeadCellProps={tableHeadCellProps}
              muiTableBodyCellProps={({ row }) => ({
                align: "left",
                sx: {
                  backgroundColor:
                    row.original.activo === 1 ? "#b3e6b3" : "#efc3c3",
                  color: "black",
                  borderColor: "black",
                },
              })}
              muiSearchTextFieldProps={{
                placeholder: "Buscar en todos los campos...",
                sx: { minWidth: "20rem", backgroundColor: "#ffffff" },
                variant: "outlined",
                color: "primary",
                size: "small",
              }}
              renderTopToolbarCustomActions={() => (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <PeopleIcon color="primary" />
                  <Typography variant="h6" fontWeight="bold">
                    Choferes
                  </Typography>
                </Box>
              )}
            />
          </Box>
        </ThemeProvider>
      </Container>
    </>
  );
}
